import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarPannelClass } from './snackbar-panel';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(private translate: TranslateService, private snackbar: MatSnackBar) { }

  async showSnackbar(message: string, pannelClass: SnackbarPannelClass) {
    var [localizedMessage, close] = await Promise.all([
      this.translate.get(message).toPromise(),
      this.translate.get("затвори").toPromise()
    ])

    this.snackbar.open(localizedMessage, close, {
      duration: 5000,
      panelClass: pannelClass
    })
  }

}
